
// src/pages/Auth/Register.js
import React from 'react';
import { Link } from 'react-router-dom';
import RegisterForm from '../../components/Auth/RegisterForm';

const Register = () => {
    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-header">
                    <div className="auth-logo">
                        <div className="avatar-circle mx-auto">
                            <i className="fas fa-user-plus"></i>
                        </div>
                    </div>
                    <h1>Registrace</h1>
                    <p className="text-muted">Vytvořte si nový účet</p>
                </div>
                <div className="auth-body">
                    <RegisterForm />
                </div>
                <div className="auth-footer">
                    <p className="mb-0">Již máte účet? <Link to="/login">Přihlaste se</Link></p>
                </div>
            </div>
        </div>
    );
};

export default Register;